const state = {
    firstName: "",
    lastName: "",
    title: "",
    avatar: "",
    theme: "",
    locale: "",
    tasks: []
}

const getters = {
    getDetails(state) {
        return state
    }
}

const mutations = {
    setDetails(state, user) {
        state.firstName = user.firstName;
        state.lastName = user.lastName;
        state.title = user.title;
        state.avatar = user.avatar;
        state.theme = user.theme;
        state.locale = user.locale;
        state.tasks = user.tasks;
    },
    setTheme(state, theme) {
        state.theme = theme;
    },
    setLocale(state, locale) {
        state.locale = locale;
    }
}

const actions = {
    setCurrentUser({ commit }, user) {
        commit("setDetails", user);
    },
}

export const loginUser = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}